<table>
    @for (day of days; track $index) {
        <tr>
            <ng-container>
                <td>{{ day | titlecase }}</td>
                <td>
                    <p-toggleswitch
                        class="p-toggleswitch"
                        [(ngModel)]="siteSchedule[day].isOpen"
                        (onChange)="handleTimeSwitchOff(day)"
                    ></p-toggleswitch>
                </td>
                <td class="time">
                    <span>
                        <p-datepicker
                            [placeholder]="defaultOpenTime"
                            [class]="'full-width'"
                            [class]="
                                siteSchedule[day]?.error?.openTimeErr
                                    ? 'time-error'
                                    : ''
                            "
                            [timeOnly]="true"
                            hourFormat="24"
                            [(ngModel)]="siteSchedule[day]['openTime']"
                            [disabled]="!siteSchedule[day].isOpen"
                            [stepMinute]="15"
                            (ngModelChange)="isValidTime(day, 'openTime')"
                        ></p-datepicker>
                        <label
                            [class]="
                                siteSchedule[day]?.error?.openTimeErr
                                    ? 'text-error'
                                    : 'hidden-text'
                            "
                            ><br />{{
                                siteSchedule[day]?.error?.openTimeErr
                            }}</label
                        >
                    </span>
                    <span>
                        <p-datepicker
                            [placeholder]="defaultCloseTime"
                            [class]="'full-width'"
                            [class]="
                                siteSchedule[day]?.error?.closeTimeErr
                                    ? 'time-error'
                                    : ''
                            "
                            [timeOnly]="true"
                            hourFormat="24"
                            [(ngModel)]="siteSchedule[day]['closeTime']"
                            [disabled]="!siteSchedule[day].isOpen"
                            [stepMinute]="15"
                            (ngModelChange)="isValidTime(day, 'closeTime')"
                        ></p-datepicker>
                        <label
                            [class]="
                                siteSchedule[day]?.error?.closeTimeErr
                                    ? 'text-error'
                                    : 'hidden-text'
                            "
                            ><br />{{
                                siteSchedule[day]?.error?.closeTimeErr
                            }}</label
                        >
                    </span>
                </td>
            </ng-container>
        </tr>
    }
</table>
<div class="footer">
    <button
        [class]="
            isValidData
                ? 'common-btn button-turquoise-bg h-2rem no-border'
                : 'common-btn button-turquoise-bg h-2rem no-border button-disabled'
        "
        (click)="onSave()"
        [disabled]="!isValidData"
    >
        Save
    </button>
    <button
        class="common-btn button-gray-bg h-2rem no-border"
        (click)="onCancel()"
    >
        Cancel
    </button>
</div>
